const publishersConfig = {
	key: 'publishers',

	fn() {
		return {
			root: 'rows',

			getURL() {
				return 'search/publishers'
			},
		}
	},
}

export { publishersConfig as default }
